<button type="button" nz-button nzType="default" (click)="showModal()" 
  nz-tooltip 
  [nzTooltipTitle]="'Upload or scan the LHDNM MyInvois-generated QR Code to extract the tax information automatically.'">
    <span nz-icon nzType="qrcode" nzTheme="outline"></span>
    <span *ngIf="!!label">{{label}}</span>
</button>

<nz-modal [nzTitle]="title" [(nzVisible)]="visible" (nzOnCancel)="closeModal()" [nzFooter]="null">
  <ng-template #title>
    <div>
      Scan Tax Payer QR Code
      <nz-tag *ngIf="live===false">Sandbox</nz-tag>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <nz-tabset [(nzSelectedIndex)]="activeTab" (nzSelectedIndexChange)="onTabChange($event)">
      <nz-tab nzTitle="Upload QR Code">
      </nz-tab>
      <nz-tab [nzTitle]="cameraTitle" [nzDisabled]="!isCameraAvailable">
        <ng-template #cameraTitle>
          <div *ngIf="checkingCamera">
            <span nz-icon nzType="loading" nzTheme="outline"></span>
            Checking Camera
          </div>
          <div *ngIf="!checkingCamera">
            {{isCameraAvailable ? 'Camera Scan' : 'Camera Not Available'}}
          </div>
        </ng-template>
      </nz-tab>
    </nz-tabset>

    <div class="camera-container">
      <div *ngIf="startingScanner" class="initializing-message">
        <span nz-icon nzType="loading" nzTheme="outline"></span>
        Initializing camera, please wait...
      </div>
      <div id="reader">
      </div>
    </div>

    <div class="upload-area" *ngIf="activeTab === 0">
      <nz-upload nzName="file" [nzBeforeUpload]="beforeUpload" [nzShowUploadList]="false" nzAccept="image/*">
        <button type="button" nz-button>
          <span nz-icon nzType="upload"></span>
          Click to Upload QR Code
        </button>
      </nz-upload>
    </div>

    <div class="text-center">
      <button type="button" nz-button nzType="text">
        <a rel="noopener" href="https://preprod.myinvois.hasil.gov.my/content?path=/userguide/Taxpayer%20QR%20Code.md" target="_blank"
          class="font-bold underline text-primary">
          <span nz-icon nzType="question-circle" nzTheme="outline" style="cursor: pointer"></span>
          How to Generate Tax Payer QR Code
        </a>
      </button>
    </div>
  </ng-container>
</nz-modal>

<nz-modal [nzTitle]="resultTitleTpl" [nzWidth]="600" [(nzVisible)]="scanResultVisible" (nzOnCancel)="scanResultVisible=false">
  <ng-template #resultTitleTpl>
    Scan Taxpayer QR Code
  </ng-template>
  <ng-container *nzModalContent>
    <div sv-container labelWidth="100" col="2">
      <sv label="Name" col="1">
        {{scanResult.name}}
      </sv>
      <sv label="ID Type">
        {{scanResult.idType}}
      </sv>
      <sv label="ID Number">
        {{scanResult.idNumber}}
      </sv>
      <sv label="TIN">
        {{scanResult.tin}}
      </sv>
      <sv label="MSIC">
        {{scanResult.msic}}
      </sv>
      <sv label="SST">
        {{scanResult.sst}}
      </sv>
      <sv label="TTX">
        {{scanResult.ttx}}
      </sv>
      <sv label="Email">
        {{scanResult.email}}
      </sv>
      <sv label="Contact">
        {{scanResult.contactNumber}}
      </sv>
      <sv label="Business" col="1">
        {{scanResult.businessActivityDescriptionEN}}
      </sv>
      <sv label="Address" col="1">
        {{scanResult.addressLine0}}<br>
        {{scanResult.addressLine1}}<br>
        {{scanResult.postalZone}} {{scanResult.city}}<br>
        {{stateName.toLocaleUpperCase()}}<br>
        {{countryName}}
      </sv>
    </div>

    <div class="update-tin-message" class="mt-md" *ngIf="!!tin">
      <p>Would you like to use this tax payer details?</p>
    </div>
  </ng-container>
  <ng-container *nzModalFooter>
    <button type="button" nz-button (click)="handleOk()">Ok</button>
  </ng-container>
</nz-modal>
